import React, { Component } from 'react'
import { 
  Button
} from '@blueprintjs/core';
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';

@inject('store', 'viewStore') @observer
class QuestionSearch extends Component {

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.questionSearch.page = 1;
    this.props.viewStore.questions();
  }

  @action
  onSearchTermChange(e) {
    
    let {
      props: {
        viewStore: {
          questionSearch
        }
      }
    } = this;
    this.props.viewStore.questionSearch = {
      ...questionSearch,
      term: e.target.value
    }
  }

  onEnter(event) {
    if (event.key === "Enter") {
      this.search()
    }
  }

  render() {
    let {
      props: {
        viewStore,
        store,
        viewStore: {
          questionSearch: { term }
        }
      }
    } = this;
    if(term == '*'){
      term = '';
    }
    return (
      <SearchFiltersToolbar
        searchButton={
          <SearchFiltersSearchButton onClick={this.search.bind(this)} />
        }
        actions={
          <Button icon={'plus'} small={true} onClick={() => viewStore.questionAdd()}>
            Add Additional Question
          </Button>
        }
      >
        <input
          type="text"
          className="bp3-input search-filters-toolbar__field-wide"
          placeholder="Label"
          onChange={this.onSearchTermChange.bind(this)}
          defaultValue={term}
          onKeyPress={this.onEnter.bind(this)}
        />
      </SearchFiltersToolbar>
    )
  }
}

export default QuestionSearch;